
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dx8CK", function(module, exports) {
$parcel$export(module.exports, "referentialityPlugin", () => (parcelRequire("1bl0g")).referentialityPlugin);
$parcel$export(module.exports, "createReferentiality", () => (parcelRequire("1bl0g")).createReferentiality);
$parcel$export(module.exports, "dataSourceResolver", () => (parcelRequire("4xvYZ")).dataSourceResolver);
$parcel$export(module.exports, "DataSourceProvider", () => (parcelRequire("lEgye")).DataSourceProvider);
$parcel$export(module.exports, "useReference", () => (parcelRequire("eVKuj")).useReference);
$parcel$export(module.exports, "ADFReferenceTypes", () => (parcelRequire("gcCrc")).ADFReferenceTypes);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $1bl0g = parcelRequire("1bl0g");


var $4xvYZ = parcelRequire("4xvYZ");


var $lEgye = parcelRequire("lEgye");


var $eVKuj = parcelRequire("eVKuj");


var $gcCrc = parcelRequire("gcCrc");


var $9oPnF = parcelRequire("9oPnF");


});

parcelRegister("1bl0g", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $4tb0i = parcelRequire("4tb0i");


var $lEgye = parcelRequire("lEgye");


var $1oCLl = parcelRequire("1oCLl");


var $cVzsl = parcelRequire("cVzsl");


var $2pjJ5 = parcelRequire("2pjJ5");


var $160re = parcelRequire("160re");


var $gcCrc = parcelRequire("gcCrc");


var $jOOx4 = parcelRequire("jOOx4");


var $8m4tT = parcelRequire("8m4tT");


var $h9yJL = parcelRequire("h9yJL");


var $2XqLN = parcelRequire("2XqLN");


var $9ge67 = parcelRequire("9ge67");


var $87lhs = parcelRequire("87lhs");

const $6e4cd1d435523f2b$var$EmitterEvents = {
    TABLE_DELETED: 'TABLE_DELETED'
};
const $6e4cd1d435523f2b$export$35dc45686fc2dbd7 = (node)=>{
    try {
        node.check();
        return true;
    } catch (err) {
        return false;
    }
};
const $6e4cd1d435523f2b$var$allowedSource = (node, schema)=>{
    const nodeName = typeof node.type === 'string' ? node.type : node.type.name;
    return [
        schema.nodes.table?.name
    ].includes(nodeName) && node.attrs?.localId;
};
const $6e4cd1d435523f2b$var$transformer = new (0, $h9yJL.JSONTransformer)();
const $6e4cd1d435523f2b$var$memoizedEncodeNode = (0, $2XqLN.default)((node)=>$6e4cd1d435523f2b$var$transformer.encodeNode(node));
function $6e4cd1d435523f2b$var$createPlugin(providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, externalObservers, options = {}, pluginInjectionApi, api, featureFlags, __livePage, __rendererExtensionOptions) {
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: !!featureFlags?.[0, $87lhs.MACRO_INTERACTION_DESIGN_UPDATES]
    };
    const showLivePagesBodiedMacrosRendererView = __rendererExtensionOptions?.isAllowedToUseRendererView;
    const extensionNodeViewOptions = {
        appearance: options.appearance,
        getExtensionHeight: options.getExtensionHeight
    };
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $4tb0i.pluginKey),
        state: {
            init () {
                const dataSourceProvider = new (0, $lEgye.DataSourceProvider)();
                const nodeMutationObserver = new (0, $cVzsl.NodeMutationObserver)(dataSourceProvider);
                externalObservers.forEach((externalObserver)=>externalObserver.init({
                        emit: (localId, data)=>dataSourceProvider.createOrUpdate(localId, data)
                    }));
                return {
                    dataSourceProvider: dataSourceProvider,
                    nodeMutationObserver: nodeMutationObserver,
                    changedSources: new Map(),
                    selectedNodeLocalId: undefined
                };
            },
            apply (tr, pluginState, state, ns) {
                let selectedNodeLocalId = pluginState.selectedNodeLocalId;
                if (!!api && !state.selection.eq(ns.selection)) {
                    const supportedNodeTypes = (0, $9ge67.getNodeTypesSupported)(state.schema);
                    const { fragment: fragment } = state.schema.marks;
                    const selectedNode = (0, $8m4tT.findSelectedNodeOfType)(supportedNodeTypes)(tr.selection) || (0, $8m4tT.findParentNodeOfType)(supportedNodeTypes)(tr.selection);
                    selectedNodeLocalId = selectedNode?.node && (fragment?.isInSet(selectedNode?.node.marks)?.attrs.localId || selectedNode?.node.attrs.localId);
                }
                const selectedLocalIdChanged = selectedNodeLocalId !== pluginState.selectedNodeLocalId;
                if (!tr.docChanged) return selectedLocalIdChanged ? {
                    ...pluginState,
                    selectedNodeLocalId: selectedNodeLocalId
                } : pluginState;
                const changedSources = new Map();
                for (const [pos, node] of pluginState.changedSources.entries()){
                    const newPos = tr.mapping.map(pos);
                    changedSources.set(newPos, node);
                }
                // Handle added/updated table node
                const changedNodes = (0, $2pjJ5.getChangedNodes)(tr).filter(({ node: node })=>{
                    // Since we are calling node validation with every interaction in useDispatchTransaction, we can safely drop the check node here to improve performance.
                    // More details: https://hello.atlassian.net/wiki/spaces/~70121ba36f99acdb4453d8f80fd8186963f3e/pages/5081212079/Optimising+typing+latency#Bonus
                    return tr.getMeta('uiEvent') !== 'cut' && $6e4cd1d435523f2b$var$allowedSource(node, state.schema);
                });
                changedNodes.forEach(({ node: sourceNode, pos: pos })=>{
                    changedSources.set(pos, sourceNode);
                });
                if (changedNodes.length) return {
                    ...pluginState,
                    changedSources: changedSources,
                    selectedNodeLocalId: selectedNodeLocalId
                };
                if (selectedLocalIdChanged) return {
                    ...pluginState,
                    selectedNodeLocalId: selectedNodeLocalId
                };
                return pluginState;
            }
        },
        view: (editorView)=>{
            api?.attach(editorView);
            const tableNodeSchema = editorView.state.schema.nodes.table;
            const pluginState = (0, $4tb0i.getPluginState)(editorView.state);
            if (!pluginState) return {};
            let handleDeleteDataSource;
            const dataSourceProvider = pluginState.dataSourceProvider;
            const nodeMutationObserver = pluginState.nodeMutationObserver;
            if (dataSourceProvider) {
                handleDeleteDataSource = (node)=>{
                    if (node && node.attrs) {
                        let tableExistsInDoc = false;
                        // ensure the destroyed node is actually not recreated
                        (0, $8m4tT.findChildrenByType)(editorView.state.doc, tableNodeSchema).forEach(({ node: existingNode })=>{
                            if (existingNode.attrs.localId === node.attrs.localId) tableExistsInDoc = true;
                        });
                        if (!tableExistsInDoc) dataSourceProvider.delete(node.attrs.localId);
                    }
                };
                eventDispatcher.on($6e4cd1d435523f2b$var$EmitterEvents.TABLE_DELETED, handleDeleteDataSource);
            }
            if (nodeMutationObserver) (0, $8m4tT.findChildrenByType)(editorView.state.doc, tableNodeSchema).forEach(({ node: node })=>{
                const fragmentLocalId = node?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
                if (fragmentLocalId) nodeMutationObserver.emit(fragmentLocalId, {
                    get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                        return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                    }
                });
                nodeMutationObserver.emit(node.attrs.localId, {
                    get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                        return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                    }
                });
            });
            return {
                update (view, prevState) {
                    const pluginState = (0, $4tb0i.getPluginState)(view.state);
                    if (!pluginState) return;
                    const prevPluginState = (0, $4tb0i.getPluginState)(prevState);
                    const { changedSources: changedSources, nodeMutationObserver: nodeMutationObserver, selectedNodeLocalId: selectedNodeLocalId } = pluginState;
                    if (selectedNodeLocalId !== prevPluginState?.selectedNodeLocalId) api?.setSelectedLocalId(selectedNodeLocalId);
                    changedSources.forEach((node, pos)=>{
                        const fragmentLocalId = node?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
                        if (fragmentLocalId) nodeMutationObserver.emit(fragmentLocalId, {
                            get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                                return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                            }
                        });
                        if (node.attrs?.localId) nodeMutationObserver.emit(node.attrs.localId, {
                            get [(0, $gcCrc.ADFReferenceTypes).TABLE] () {
                                return $6e4cd1d435523f2b$var$memoizedEncodeNode(node);
                            }
                        });
                    });
                    changedSources.clear();
                },
                destroy () {
                    api?.detach();
                    if (dataSourceProvider) {
                        eventDispatcher.off($6e4cd1d435523f2b$var$EmitterEvents.TABLE_DELETED, handleDeleteDataSource);
                        if (dataSourceProvider.clear) dataSourceProvider.clear();
                    }
                }
            };
        },
        props: {
            nodeViews: {
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                extension: (0, $160re.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, (0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) ? options.intl : undefined),
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                bodiedExtension: (0, $160re.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, __rendererExtensionOptions?.showUpdated1PBodiedExtensionUI, __rendererExtensionOptions?.rendererExtensionHandlers, (0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) ? options.intl : undefined),
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                inlineExtension: (0, $160re.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, (0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) ? options.intl : undefined)
            }
        }
    });
}
const $6e4cd1d435523f2b$export$9d03c288c4007750 = ({ config: options, api: pluginInjectionApi })=>({
        name: 'referentiality',
        pmPlugins () {
            return [
                {
                    name: 'referentiality',
                    plugin: ({ providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const extensionHandlers = options?.extensionHandlers ?? {};
                        const externalObservers = options?.externalObservers ?? [];
                        return $6e4cd1d435523f2b$var$createPlugin(providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, externalObservers, {
                            appearance: options?.appearance,
                            getExtensionHeight: options?.getExtensionHeight,
                            intl: getIntl()
                        }, pluginInjectionApi, options?.api, options?.featureFlags, options?.__livePage, options?.__rendererExtensionOptions);
                    }
                }
            ];
        }
    });
const $6e4cd1d435523f2b$export$7e7e0965a9844ba0 = (options)=>{
    const api = options?.api ?? new (0, $jOOx4.ReferentialityAPIImpl)(options);
    return {
        api: api,
        plugin: $6e4cd1d435523f2b$export$9d03c288c4007750({
            config: {
                ...options,
                api: api
            }
        })
    };
};
module.exports["referentialityPlugin"] = $6e4cd1d435523f2b$export$9d03c288c4007750;
module.exports["createReferentiality"] = $6e4cd1d435523f2b$export$7e7e0965a9844ba0;

});

parcelRegister("4tb0i", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $37c64d6535cfb5cb$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('referentialityPlugin');
const $37c64d6535cfb5cb$export$f05434c51e3762e = (state)=>state && $37c64d6535cfb5cb$export$18d4026d1ea86bb1.getState(state);
module.exports["pluginKey"] = $37c64d6535cfb5cb$export$18d4026d1ea86bb1;
module.exports["getPluginState"] = $37c64d6535cfb5cb$export$f05434c51e3762e;

});

parcelRegister("lEgye", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
class $9eb3f7291ea30683$export$83ebb6424014532f {
    createOrUpdate(id, reference) {
        this.dataSources.set(id, reference);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const requestCallback = window.requestIdleCallback || window.requestAnimationFrame;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const cancelCallback = window.cancelIdleCallback || window.cancelAnimationFrame;
        // TODO: ED-26962 - refactor if needed - https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/8012/ed-11927-data-source-provider#comment-206010499
        const callbackId = requestCallback(()=>{
            cancelCallback(callbackId);
            this.notifySubscribers(id, reference);
        });
    }
    notifySubscribers(id, reference) {
        if (this.subscriptions.has(id)) this.subscriptions.get(id)?.forEach((callback)=>{
            callback(reference);
        });
    }
    subscribe(id, callback) {
        if (!this.subscriptions.has(id)) this.subscriptions.set(id, new Set());
        this.subscriptions.get(id)?.add(callback);
    }
    unsubscribe(id, callback) {
        if (!this.subscriptions.has(id)) return;
        this.subscriptions.get(id)?.delete(callback);
    }
    delete(id) {
        this.dataSources.delete(id);
        this.notifySubscribers(id, null);
    }
    get(id) {
        return this.dataSources.get(id) || null;
    }
    clear() {
        this.dataSources.clear();
        this.subscriptions.clear();
    }
    constructor(){
        this.subscriptions = new Map();
        this.dataSources = new Map();
    }
}
module.exports["DataSourceProvider"] = $9eb3f7291ea30683$export$83ebb6424014532f;

});

parcelRegister("cVzsl", function(module, exports) {
class $26165acd862f475d$export$ab608a64509503ae {
    emit(id, adfReference) {
        this.dataSourceProvider.createOrUpdate(id, adfReference);
    }
    constructor(dataSourceProvider){
        this.dataSourceProvider = void 0;
        this.dataSourceProvider = dataSourceProvider;
    }
}
module.exports["NodeMutationObserver"] = $26165acd862f475d$export$ab608a64509503ae;

});

parcelRegister("160re", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a0ebb093ddd3646$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gjBRE = parcelRequire("gjBRE");

var $3oRlx = parcelRequire("3oRlx");


var $jt8MB = parcelRequire("jt8MB");


var $4tb0i = parcelRequire("4tb0i");

class $9a0ebb093ddd3646$export$63dcdbe82ab2119 extends (0, $gjBRE.ExtensionNode) {
    render(props, forwardRef) {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3oRlx.ExtensionNodeWrapper), {
            intl: props.intl,
            nodeType: this.node.type.name,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jt8MB.default), {
                editorAppearance: props.extensionNodeViewOptions.appearance,
                editorView: this.view,
                node: this.node,
                // The getPos arg is always a function when used with nodes
                // the version of the types we use has a union with the type
                // for marks.
                // This has been fixed in later versions of the definitly typed
                // types (and also in prosmirror-views inbuilt types).
                // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
                getPos: this.getPos,
                providerFactory: props.providerFactory,
                handleContentDOMRef: forwardRef,
                extensionHandlers: props.extensionHandlers,
                dataSourceProvider: props.dataSourceProvider,
                pluginInjectionApi: props.pluginInjectionApi,
                macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
                showLivePagesBodiedMacrosRendererView: props.showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: props.showUpdatedLivePages1PBodiedExtensionUI,
                rendererExtensionHandlers: props.rendererExtensionHandlers
            })
        });
    }
}
function $9a0ebb093ddd3646$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers, intl) {
    return (node, view, getPos)=>{
        const pluginState = (0, $4tb0i.getPluginState)(view.state);
        return new $9a0ebb093ddd3646$export$63dcdbe82ab2119(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            extensionNodeViewOptions: extensionNodeViewOptions,
            dataSourceProvider: pluginState?.dataSourceProvider,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: rendererExtensionHandlers,
            intl: intl
        }).init();
    };
}

});

parcelRegister("jt8MB", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fPlBD = parcelRequire("fPlBD");

const $5a206d91b5b3f476$export$eba5603251c4feaf = ({ editorView: editorView, node: node, dataSourceProvider: dataSourceProvider })=>{
    const dataSourceId = node.marks?.find((mark)=>mark.type === editorView.state.schema.marks?.dataConsumer)?.attrs?.sources?.[0];
    const [reference, setReference] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(()=>{
        const dataSourceReference = dataSourceProvider?.get(dataSourceId);
        if (dataSourceReference) return dataSourceReference;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        dataSourceProvider?.unsubscribe(dataSourceId, setReference);
        dataSourceProvider?.subscribe(dataSourceId, setReference);
        return ()=>dataSourceProvider?.unsubscribe(dataSourceId, setReference);
    }, [
        dataSourceProvider,
        dataSourceId
    ]);
    return reference ? [
        reference
    ] : [];
};
const $5a206d91b5b3f476$var$ExtensionWithDataSource = (props)=>{
    const reference = $5a206d91b5b3f476$export$eba5603251c4feaf(props);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fPlBD.Extension), {
        ...props,
        references: reference
    });
};
var $5a206d91b5b3f476$export$2e2bcd8739ae039 = $5a206d91b5b3f476$var$ExtensionWithDataSource;
module.exports["default"] = $5a206d91b5b3f476$export$2e2bcd8739ae039;

});

parcelRegister("gcCrc", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
var $b1f12d58a935bfc6$export$eeab3cae4ffcf74a = /*#__PURE__*/ function(ADFReferenceTypes) {
    ADFReferenceTypes["TABLE"] = "table-adf";
    return ADFReferenceTypes;
}({});
var $b1f12d58a935bfc6$export$5cb1f459478c70e = /*#__PURE__*/ function(MEASURE_NAME) {
    MEASURE_NAME["INITIALISE_FRAGMENT_MARKS"] = "initialiseFragmentMarks";
    MEASURE_NAME["CONNECT_NODES"] = "connectNodes";
    MEASURE_NAME["UPDATE_SOURCE"] = "updateSource";
    MEASURE_NAME["DISCONNECT_SOURCE"] = "disconnectSource";
    MEASURE_NAME["UPDATE_TARGET"] = "updateTarget";
    MEASURE_NAME["DISCONNECT_TARGET"] = "disconnectTarget";
    MEASURE_NAME["UPDATE_FRAGMENT_MARK_NAME"] = "updateFragmentMarkName";
    MEASURE_NAME["GET_CONNECTIONS"] = "getConnections";
    return MEASURE_NAME;
}({});
module.exports["ADFReferenceTypes"] = $b1f12d58a935bfc6$export$eeab3cae4ffcf74a;
module.exports["MEASURE_NAME"] = $b1f12d58a935bfc6$export$5cb1f459478c70e;

});

parcelRegister("jOOx4", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $fO7hX = parcelRequire("fO7hX");


var $h9yJL = parcelRequire("h9yJL");


var $2T4ch = parcelRequire("2T4ch");


var $gcCrc = parcelRequire("gcCrc");


var $aoIzw = parcelRequire("aoIzw");


var $9oPnF = parcelRequire("9oPnF");


var $9ge67 = parcelRequire("9ge67");


var $2PvyV = parcelRequire("2PvyV");

class $e9714976d4e11162$export$6a5e825be2d43d52 {
    get isAttached() {
        return !!this.editorView;
    }
    attach(editorView) {
        const { state: { schema: schema } } = editorView;
        if (!schema.marks.fragment) throw new (0, $9oPnF.CompatibilityError)('fragmentMark not supported');
        this.editorView = editorView;
    }
    detach() {
        this.editorView = undefined;
    }
    setNodeFocusCallback(callback) {
        this.nodeFocusCallback = callback;
    }
    setNodeNameCallback(callback) {
        this.nodeNameCallback = callback;
    }
    setSelectedLocalId(localId) {
        if (this.selectedLocalId === localId) return;
        this.selectedLocalId = localId;
        if (!!this.nodeFocusCallback) {
            if (!localId) {
                this.nodeFocusCallback(undefined);
                return;
            }
            if (this.editorView) {
                const { state: state } = this.editorView;
                const foundNode = (0, $9ge67.findNodeByLocalId)(localId, state);
                if (foundNode) this.nodeFocusCallback((0, $9ge67.createLinkNode)(this.normalizeLocalId(localId, foundNode.fragmentMark?.attrs.localId), foundNode.fragmentMark?.attrs.name || '', foundNode.node));
            }
        }
    }
    initialiseFragmentMarks() {
        if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('initialiseFragmentMarks');
        (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).INITIALISE_FRAGMENT_MARKS);
        const { state: state, dispatch: dispatch } = this.editorView;
        let { tr: tr } = state;
        const docSize = state.doc.nodeSize;
        const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId, false);
        let count = 0;
        const maxNumberUsedInFragmentMarkNames = context.getMaxNumberUsedInFragmentMarkNames();
        for (const target of context.namelessOnlyConnections()){
            const { markNameWithNumber: markNameWithNumber, markName: markName, markNameNumber: markNameNumber } = (0, $9ge67.generateMarkNameWithNumber)(target.node, state.schema, maxNumberUsedInFragmentMarkNames, this.nodeNameCallback);
            maxNumberUsedInFragmentMarkNames[markName] = markNameNumber;
            tr = (0, $9ge67.updateFragmentName)(state.schema, target, markNameWithNumber)(tr);
            count++;
        }
        tr.setMeta('addToHistory', false);
        (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).INITIALISE_FRAGMENT_MARKS, (0, $2PvyV.captureInitialiseFragmentMarksEvent)({
            docSize: docSize,
            count: count,
            tr: tr,
            editorAnalyticsAPI: this.editorAnalyticsAPI
        }));
        dispatch(tr);
    }
    getConnections() {
        (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).GET_CONNECTIONS);
        const result = {};
        if (!this.editorView) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).GET_CONNECTIONS);
            return result;
        }
        const { state: { tr: tr, doc: { nodeSize: nodeSize } } } = this.editorView;
        const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
        // First initialize all possible connection linkages
        for (const { node: node, normalizedId: normalizedId, name: name } of context.uniqueConnections())result[normalizedId] = (0, $9ge67.createConnectionLink)(node, normalizedId, name);
        // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
        for (const { normalizedId: normalizedId, dataConsumer: dataConsumer } of context.consumerOnlyConnections()){
            // This is a ref to the node (connection link) which contains the consumer.
            const currentNodeLink = result[normalizedId];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dataConsumer.attrs.sources.forEach((src)=>{
                const normalizedSrcId = context.getById(src)?.normalizedId ?? src;
                const srcLink = result[normalizedSrcId];
                if (srcLink && normalizedSrcId !== normalizedId) {
                    srcLink.targets.push(normalizedId);
                    currentNodeLink?.sources.push(normalizedSrcId);
                }
            });
        }
        (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).GET_CONNECTIONS, (0, $2PvyV.captureGetConnectionsEvent)({
            tr: tr,
            editorAnalyticsAPI: this.editorAnalyticsAPI,
            docSize: nodeSize,
            count: Object.keys(result).length
        }));
        return result;
    }
    select(localId, scroll = false) {
        if (!this.editorView || !localId) throw new (0, $9oPnF.ConfigurationError)('select');
        const { state: state, dispatch: dispatch } = this.editorView;
        const foundNode = (0, $9ge67.findNodeByLocalId)(localId, state);
        if (foundNode) {
            const { tr: tr } = state;
            tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, foundNode.pos));
            if (scroll) tr.scrollIntoView();
            tr.setMeta('addToHistory', false);
            dispatch(tr);
        }
    }
    updateName(localId, name) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME);
            if (!this.isAttached || !this.editorView) throw new (0, $9oPnF.ConfigurationError)('updateName');
            const { state: state, state: { schema: schema }, dispatch: dispatch } = this.editorView;
            const foundNode = (0, $9ge67.findNodeByLocalId)(localId, state);
            if (!foundNode) throw new (0, $9oPnF.NodeNotFoundError)(localId);
            const { fragment: fragment } = schema.marks;
            const { fragmentMark: fragmentMark, node: node, pos: pos } = foundNode;
            const fragLocalId = fragmentMark?.attrs.localId ?? (0, $fO7hX.uuid).generate();
            const nextFragmentMark = fragment.create({
                localId: fragLocalId,
                name: name
            });
            const nextMarks = fragmentMark ? node.marks.filter((mark)=>mark.type !== nextFragmentMark.type) : node.marks.concat();
            nextMarks.push(nextFragmentMark);
            // ensure the fragment mark on the node has the correct id & name.
            const tr = state.tr.setNodeMarkup(pos, undefined, node.attrs, nextMarks);
            dispatch(tr);
            const linkNode = (0, $9ge67.createLinkNode)(this.normalizeLocalId(node.attrs.localId, fragLocalId), name, node);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME, (0, $2PvyV.captureUpdateFragmentMarkNameEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                nodeType: node.type.name
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME);
            throw e;
        }
    }
    getADFFromLocalId(localId) {
        if (!this.isAttached || !this.editorView) throw new (0, $9oPnF.ConfigurationError)('getADFFromLocalId');
        const { state: state } = this.editorView;
        const foundNode = (0, $9ge67.findNodeByLocalId)(localId, state);
        if (!foundNode) throw new (0, $9oPnF.NodeNotFoundError)(localId);
        return new (0, $h9yJL.JSONTransformer)().encodeNode(foundNode.node);
    }
    connectSource(targetLocalId, sourceLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('connectSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { source: source, target: target, tr: tr } = (0, $9ge67.connectNodes)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $2PvyV.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectSource',
                type: 'connect',
                sourceNodeType: source.node.type,
                targetNodeType: target.node.type
            }));
            return source;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    connectTarget(sourceLocalId, targetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('connectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { source: source, target: target, tr: tr } = (0, $9ge67.connectNodes)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $2PvyV.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectTarget',
                type: 'connect',
                sourceNodeType: source.node.type,
                targetNodeType: target.node.type
            }));
            return target;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    updateTarget(sourceLocalId, oldTargetLocalId, newTargetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('updateTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { target: target, source: source, tr: tr } = (0, $9ge67.connectNodes)(context, newTargetLocalId, sourceLocalId, (0, $9ge67.disconnectNodes)(context, oldTargetLocalId, sourceLocalId, state.tr));
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET, (0, $2PvyV.captureUpdateTargetEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                newTargetNodeType: target.node.type,
                oldTargetNodeType: context.getById(oldTargetLocalId)?.node.type.name || '',
                sourceNodeType: source.node.type,
                type: 'update'
            }));
            return target;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            throw e;
        }
    }
    updateSource(targetLocalId, newSourceLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('updateSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { target: target, source: source, tr: tr } = (0, $9ge67.resetNodes)(context, targetLocalId, newSourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE, (0, $2PvyV.captureUpdateSourceEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                oldSourceNodeType: target.node.type,
                newSourceNodeType: source.node.type,
                type: 'update'
            }));
            return source;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            throw e;
        }
    }
    disconnectTarget(sourceLocalId, targetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_TARGET);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('disconnectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const tr = (0, $9ge67.disconnectNodes)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_TARGET, (0, $2PvyV.captureDisconnectTargetEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || '',
                targetNodeType: context.getById(targetLocalId)?.node.type.name || ''
            }));
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_TARGET);
            throw e;
        }
    }
    disconnectSource(targetLocalId) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_SOURCE);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('disconnectSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const target = (0, $9ge67.findNodeByLocalId)(targetLocalId, state);
            if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
            const tr = (0, $9ge67.updateNodeSources)(state.schema, target.node, target.pos)(state.tr);
            dispatch(tr);
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_SOURCE, (0, $2PvyV.captureDisconnectSourceEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                targetNodeType: target.node.type.name
            }));
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).DISCONNECT_SOURCE);
            throw e;
        }
    }
    insertAndConnectTarget(sourceLocalId, target) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('insertAndConnectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { linkNode: linkNode, tr: tr } = (0, $9ge67.insertTarget)(context, sourceLocalId, target, state.tr, this.nodeNameCallback);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $2PvyV.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectTarget',
                type: 'insertAndConnect',
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || '',
                targetNodeType: target.type
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    insertAndConnectSource(targetLocalId, source) {
        try {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('insertAndConnectSource');
            const { state: state, state: { schema: schema }, dispatch: dispatch } = this.editorView;
            const nodeType = schema.nodes[source.type];
            if (!(0, $9ge67.getNodesSupportingFragmentMark)(schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(source.type);
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const target = context.getById(targetLocalId);
            if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
            const { linkNode: linkNode, node: node } = (0, $9ge67.createLinkElementNode)(context, source, this.nodeNameCallback);
            let tr = state.tr;
            const targetSources = (0, $9ge67.normalizeIds)(context, target.dataConsumer?.attrs.sources).add(linkNode.localId);
            tr = (0, $9ge67.updateSources)(schema, target, targetSources)(tr);
            tr = (0, $9ge67.insertNodeAfter)(targetLocalId, node, state, tr);
            tr = tr.setMeta('referentialityTableInserted', node.type.name === schema.nodes.table.name);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES, (0, $2PvyV.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectSource',
                type: 'insertAndConnect',
                sourceNodeType: node.type.name,
                targetNodeType: context.getById(targetLocalId)?.node.type.name || ''
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    replaceAndUpdateTarget(sourceLocalId, oldTargetLocalId, newTarget) {
        try {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('replaceAndUpdateTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { linkNode: linkNode, tr: tr } = (0, $9ge67.insertTarget)(context, sourceLocalId, newTarget, state.tr, this.nodeNameCallback, oldTargetLocalId);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET, (0, $2PvyV.captureUpdateTargetEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                type: 'replaceAndUpdate',
                newTargetNodeType: newTarget.type,
                oldTargetNodeType: context.getById(oldTargetLocalId)?.node.type.name || '',
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || ''
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_TARGET);
            throw e;
        }
    }
    replaceAndUpdateSource(targetLocalId, newSource) {
        try {
            (0, $2T4ch.startMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            if (!this.editorView) throw new (0, $9oPnF.ConfigurationError)('replaceAndUpdateSource');
            const { state: { schema: schema }, state: state, dispatch: dispatch } = this.editorView;
            const nodeType = schema.nodes[newSource.type];
            if (!(0, $9ge67.getNodesSupportingFragmentMark)(schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(newSource.type);
            const context = new (0, $aoIzw.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const target = context.getById(targetLocalId);
            if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
            const { linkNode: linkNode, node: node } = (0, $9ge67.createLinkElementNode)(context, newSource, this.nodeNameCallback);
            let tr = (0, $9ge67.updateSources)(context.schema, target, new Set([
                linkNode.localId
            ]))(state.tr);
            tr = (0, $9ge67.insertNodeAfter)(targetLocalId, node, state, tr);
            tr = tr.setMeta('referentialityTableInserted', node.type.name === schema.nodes.table.name);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE, (0, $2PvyV.captureUpdateSourceEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                oldSourceNodeType: target.node.type.name,
                newSourceNodeType: newSource.type,
                type: 'replaceAndUpdate'
            }));
            return linkNode;
        } catch (e) {
            (0, $2T4ch.stopMeasure)((0, $gcCrc.MEASURE_NAME).UPDATE_SOURCE);
            throw e;
        }
    }
    /**
   * @constructor
   */ constructor({ nodeNameCallback: nodeNameCallback, nodeFocusCallback: // you can also set this callback using setNodeNameCallback method
    nodeFocusCallback, editorAnalyticsAPI: // you can also set this callback using setNodeFocusCallback method
    editorAnalyticsAPI, editorView: editorView, featureFlags: featureFlags } = {}){
        this.nodeNameCallback = void 0;
        this.nodeFocusCallback = void 0;
        this.normalizeLocalId = void 0;
        this.editorAnalyticsAPI = void 0;
        this.editorView = void 0;
        this.selectedLocalId = void 0;
        this.nodeNameCallback = nodeNameCallback;
        this.nodeFocusCallback = nodeFocusCallback;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
        this.editorView = editorView;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.normalizeLocalId = (attrsLocalId, fragmentLocalId)=>fragmentLocalId ?? attrsLocalId;
    }
}
module.exports["ReferentialityAPIImpl"] = $e9714976d4e11162$export$6a5e825be2d43d52;

});

parcelRegister("aoIzw", function(module, exports) {

var $9ge67 = parcelRequire("9ge67");

class $d8399198c52b1afb$export$3e2fc71d3c4adf01 {
    /**
   * Convenience helper to get the EditorState
   */ get state() {
        return this.view.state;
    }
    /**
   * Convenience helper to get the Schema
   */ get schema() {
        return this.view.state.schema;
    }
    getById(localId) {
        return this.connections.get(localId);
    }
    hasId(localId) {
        return this.connections.has(localId);
    }
    getMaxNumberUsedInFragmentMarkNames() {
        return {
            ...this.maxNumberUsedInFragmentMarkName
        };
    }
    getMaxNumberUsedInFragmentMarkName(name) {
        return this.maxNumberUsedInFragmentMarkName[name] ?? 0;
    }
    updateMaxNumberUsedInFragmentMarkNames(name, value) {
        this.maxNumberUsedInFragmentMarkName[name] = value;
    }
    *uniqueConnections() {
        for (const id of this.uniqueNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * This generator will only return connections which contain DataConsumer sources.
   */ *consumerOnlyConnections() {
        for (const id of this.uniqueNormalizedIds){
            const connection = this.connections.get(id);
            if (connection && !!connection.dataConsumer?.attrs.sources.length) yield connection;
        }
    }
    /**
   * This generator will only return connections which are sources
   */ *sourceOnlyConnections() {
        for (const id of this.uniqueSourceNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * This generator will return connections which do not contain a name or fragment
   */ *namelessOnlyConnections() {
        for (const id of this.namelessNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * @constructor
   * @param view
   * @param shallow A flag to help identify the depth of scan required. This default to true. A Shallow context assumes
   * that nodes with data consumers cannot contain descendants with fragmentMarks or dataConsumers
   */ constructor(view, normalizeLocalId, shallow = true){
        this.view = view;
        this.normalizeLocalId = normalizeLocalId;
        this.shallow = shallow;
        /**
     * This record is used to keep track of the max number in each fragment name.
     */ this.maxNumberUsedInFragmentMarkName = {};
        /**
     * This map enables quick lookup of all unnormalized connections
     */ this.connections = new Map();
        /**
     * This is a unique set containing only normalized localIds
     */ this.uniqueNormalizedIds = new Set();
        /**
     * This is a unique set containing only normalized localIds
     */ this.uniqueSourceNormalizedIds = new Set();
        /**
     * This is a unique set of normalized localIds which are nameless
     */ this.namelessNormalizedIds = new Set();
        const { doc: doc, schema: schema } = this.view.state;
        const { fragment: fragment, dataConsumer: dataConsumer } = schema.marks;
        const nodesSupportingFragmentMark = (0, $9ge67.getNodesSupportingFragmentMark)(schema);
        const sourceToTargetMappings = new Map();
        doc.descendants((node, pos, parent)=>{
            if (!nodesSupportingFragmentMark.has(node.type)) return true;
            const fragmentMark = fragment.isInSet(node.marks);
            // If node cannot be referenced by any means then abort.
            if (!fragmentMark && !node.attrs?.localId) return true;
            const normalizedId = this.normalizeLocalId(node.attrs?.localId, fragmentMark?.attrs?.localId);
            if (!normalizedId || this.connections.has(normalizedId)) return true;
            let decodedName;
            if (!!fragmentMark?.attrs.name) {
                decodedName = (0, $9ge67.decodeName)(fragmentMark.attrs.name);
                if (decodedName) {
                    const currentMax = this.maxNumberUsedInFragmentMarkName[decodedName.defaultName];
                    if (currentMax === undefined || currentMax < decodedName.defaultNameNumber) this.maxNumberUsedInFragmentMarkName[decodedName.defaultName] = decodedName.defaultNameNumber;
                }
            } else this.namelessNormalizedIds.add(normalizedId);
            const consumer = dataConsumer.isInSet(node.marks);
            const ref = {
                node: node,
                pos: pos,
                parent: parent,
                normalizedId: normalizedId,
                name: fragmentMark?.attrs?.name ?? normalizedId,
                ids: new Set(),
                targets: new Set(),
                fragmentMark: fragmentMark,
                dataConsumer: consumer,
                decodedName: decodedName
            };
            if (!!fragmentMark?.attrs?.localId) {
                ref.ids.add(fragmentMark.attrs.localId);
                this.connections.set(fragmentMark.attrs.localId, ref);
            }
            if (!!node.attrs?.localId) {
                ref.ids.add(node.attrs.localId);
                this.connections.set(node.attrs.localId, ref);
            }
            this.uniqueNormalizedIds.add(normalizedId);
            if (consumer) // A lookup map of srcId -> targetId[]. This enables quickly finding all nodes
            // which consume a specific source.
            consumer.attrs.sources.forEach((src)=>sourceToTargetMappings.set(src, sourceToTargetMappings.get(src)?.add(normalizedId) ?? new Set([
                    normalizedId
                ])));
            // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
            // be referenced by another node. Unless of course this is not a shallow context.
            // if consumer: true & shallow: true -> return false // don't descend
            // if consumer: false & shallow: true -> return true // descend
            // if consumer: true & shallow: false -> return true // descend
            // if consumer: false & shallow: false -> return true // descend
            return !(shallow && consumer);
        });
        // This 2nd-pass is used to normalize all the source ids. We need to have full context before we're able to do this.
        for (const [source, targets] of sourceToTargetMappings){
            const connection = this.connections.get(source);
            if (connection) {
                this.uniqueSourceNormalizedIds.add(connection.normalizedId);
                connection.targets = new Set([
                    ...connection.targets,
                    ...targets
                ]);
            }
        }
    }
}
module.exports["ReferentialityContext"] = $d8399198c52b1afb$export$3e2fc71d3c4adf01;

});

parcelRegister("9ge67", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $fO7hX = parcelRequire("fO7hX");


var $h9yJL = parcelRequire("h9yJL");


var $8m4tT = parcelRequire("8m4tT");


var $9oPnF = parcelRequire("9oPnF");

const $2e1ac7157de99f01$export$8174b2693cae81eb = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return [
        table,
        extension,
        bodiedExtension,
        inlineExtension
    ];
};
const $2e1ac7157de99f01$export$3fdc75161fb8ee49 = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return new Map([
        [
            table,
            'Table'
        ],
        [
            extension,
            'Extension'
        ],
        [
            bodiedExtension,
            'Extension'
        ],
        [
            inlineExtension,
            'Extension'
        ]
    ]);
};
const $2e1ac7157de99f01$export$549d0eefc6fd05c0 = (schema)=>{
    const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return new Set([
        extension,
        bodiedExtension,
        inlineExtension
    ].filter(Boolean));
};
const $2e1ac7157de99f01$export$54a3e405bb0d0a4a = (node, id, name)=>({
        linkNode: {
            localId: id,
            name: name ?? id,
            node: {
                type: node.type.name,
                attrs: {
                    ...node.attrs
                }
            }
        },
        sources: [],
        targets: []
    });
const $2e1ac7157de99f01$export$368b1080eb192086 = (name)=>{
    const splitName = name.split(' '); // ['Awesome', 'list', '2.0', '5']
    if (splitName.length < 2) return null;
    const lastNumberInName = Number(splitName[splitName.length - 1]);
    if (typeof lastNumberInName !== 'number') return null;
    const nameWithoutLastNumber = splitName.slice(0, splitName.length - 1) // ['Awesome', 'list', '2.0']
    .join(' '); // 'Awesome list 2.0'
    return {
        defaultName: nameWithoutLastNumber,
        defaultNameNumber: lastNumberInName
    };
};
const $2e1ac7157de99f01$export$8a9a3ce4139f59c3 = ({ type: type, attrs: attrs }, schema, fragmentMarkNameLastNumbers, nodeNameCallback)=>{
    const nodesSupportingFragmentMark = $2e1ac7157de99f01$export$3fdc75161fb8ee49(schema);
    const nodesSupportingNameCallback = $2e1ac7157de99f01$export$549d0eefc6fd05c0(schema);
    let markName = '';
    if (nodesSupportingNameCallback.has(type)) {
        if (nodeNameCallback) markName = nodeNameCallback({
            node: {
                type: type.name,
                attrs: attrs
            }
        });
    }
    if (!markName) markName = nodesSupportingFragmentMark.get(type) ?? 'Element';
    const markNameNumber = (fragmentMarkNameLastNumbers?.[markName] ?? 0) + 1;
    return {
        markNameWithNumber: `${markName} ${markNameNumber}`,
        markName: markName,
        markNameNumber: markNameNumber
    };
};
const $2e1ac7157de99f01$export$7503e197531554a8 = ({ normalizedId: normalizedId, name: name, node: node })=>$2e1ac7157de99f01$export$dbdf2d08277c626e(normalizedId, name, node);
const $2e1ac7157de99f01$export$dbdf2d08277c626e = (localId, name, node)=>{
    const jsonNode = new (0, $h9yJL.JSONTransformer)().encodeNode(node);
    return {
        localId: localId,
        name: name,
        node: {
            type: jsonNode.type,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            attrs: jsonNode.attrs
        }
    };
};
const $2e1ac7157de99f01$export$c85fa7574bd3ee0b = (context, target, source)=>{
    if (target.normalizedId === source.normalizedId) return true;
    // Try and get a consumer from the source, this is because we don't care about the initial link between target -> source
    // we only care if somewhere down the chain after the source; is there a link back to this target.
    return !!source.dataConsumer?.attrs.sources.some((src)=>{
        const nextSrc = context.getById(src);
        return !!nextSrc && $2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, nextSrc);
    });
};
const $2e1ac7157de99f01$export$b25165d24a0db921 = (state, localId)=>{
    let found = false;
    const { doc: doc, schema: schema } = state;
    const { fragment: fragment } = schema.marks;
    const nodesSupportingFragmentMark = $2e1ac7157de99f01$export$3fdc75161fb8ee49(schema);
    // TODO: ED-26962 - Update scanning method to abort the scan immediately once a node has been found.
    doc.descendants((node)=>{
        if (found) return false;
        if (!nodesSupportingFragmentMark.has(node.type)) return true;
        if (node.attrs?.localId === localId) {
            found = true;
            return false;
        }
        const fragmentMark = fragment.isInSet(node.marks);
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark) return true;
        if (fragmentMark?.attrs?.localId === localId) found = true;
        return !found;
    });
    return found;
};
const $2e1ac7157de99f01$export$aadcc3ba2430b = (localId, state)=>{
    const { doc: doc, schema: schema } = state;
    const fragment = schema.marks.fragment;
    const nodesSupportingFragmentMark = $2e1ac7157de99f01$export$3fdc75161fb8ee49(schema);
    let foundNode = null;
    doc.descendants((node, pos)=>{
        if (foundNode) return false;
        if (!nodesSupportingFragmentMark.has(node.type)) return true;
        const existingFragmentMark = fragment.isInSet(node.marks) ?? null;
        if (existingFragmentMark && existingFragmentMark.attrs.localId === localId) {
            foundNode = {
                node: node,
                pos: pos,
                fragmentMark: existingFragmentMark
            };
            return false;
        }
        if (node.attrs.localId === localId) {
            foundNode = {
                node: node,
                pos: pos,
                fragmentMark: existingFragmentMark
            };
            return false;
        }
        return true;
    });
    return foundNode;
};
const $2e1ac7157de99f01$export$ebf688cb60f59a94 = (schema, localId, name, sources)=>{
    const { fragment: fragment, dataConsumer: dataConsumer } = schema.marks;
    return [
        fragment.create({
            localId: localId,
            name: name
        }),
        sources && dataConsumer.create({
            sources: Array.from(sources) ?? []
        })
    ].filter(Boolean);
};
const $2e1ac7157de99f01$export$270e7ba5936d3c48 = (schema, type, attrs, marks)=>{
    const { table: table } = schema.nodes;
    const createNodeContent = type === table ? $2e1ac7157de99f01$export$d142f815ac656d : $2e1ac7157de99f01$export$85ceaeb5400c34da;
    return type.createChecked({
        ...attrs,
        localId: (0, $fO7hX.uuid).generate()
    }, createNodeContent(schema, type), marks);
};
const $2e1ac7157de99f01$export$d142f815ac656d = (schema, type)=>{
    const { tableCell: tableCell, tableHeader: tableHeader, tableRow: tableRow } = schema.nodes;
    const cells = [];
    const headerCells = [];
    for(let i = 0; i < 3; i++){
        const cell = tableCell.createAndFill();
        if (cell) cells.push(cell);
        const headerCell = tableHeader.createAndFill();
        if (headerCell) headerCells.push(headerCell);
    }
    const rows = [];
    for(let i = 0; i < 3; i++)rows.push(tableRow.createChecked(null, i === 0 ? headerCells : cells));
    return rows;
};
const $2e1ac7157de99f01$export$85ceaeb5400c34da = (schema, type)=>{
    const { bodiedExtension: bodiedExtension, paragraph: paragraph } = schema.nodes;
    if (type === bodiedExtension) return [
        paragraph.createChecked()
    ];
    return (0, $5SAOw.Fragment).empty;
};
const $2e1ac7157de99f01$export$9c63b8d16fa708c5 = (localId, node, state, tr, options)=>{
    tr = tr ?? state.tr;
    const nodePos = $2e1ac7157de99f01$export$aadcc3ba2430b(localId, state);
    const insertPosition = nodePos ? nodePos.pos + nodePos.node.nodeSize : undefined;
    tr = (0, $8m4tT.safeInsert)(node, insertPosition)(tr);
    return tr;
};
const $2e1ac7157de99f01$export$4c47e28146a39728 = (context, ids)=>{
    return ids?.reduce((idSet, id)=>{
        const ns = context.getById(id)?.normalizedId;
        // filters out undefined, null or empty items
        return !!ns ? idSet.add(ns) : idSet;
    }, new Set()) ?? new Set();
};
const $2e1ac7157de99f01$export$6c4da287bd77d75c = (schema, target, sources)=>(tr)=>$2e1ac7157de99f01$export$884cb393b34cee0d(schema, target.node, target.pos, sources, target.dataConsumer)(tr);
const $2e1ac7157de99f01$export$884cb393b34cee0d = (schema, node, pos, sources, consumer)=>(tr)=>{
        const { dataConsumer: dataConsumer } = schema.marks;
        const currentSources = (consumer ?? dataConsumer.isInSet(node.marks))?.attrs.sources;
        // Quick Check: No point in updating node markup if nothing is changing.
        if (!sources?.size && !currentSources?.length) return tr;
        // This attempts to check deep equality. If the sizes are not the same or a source is different to what's being set; then
        // we want to perform the markup change, otherwise we should avoid unnecessary transactions.
        if (sources?.size === currentSources?.length && currentSources.every((src)=>sources.has(src))) return tr;
        const marks = (dataConsumer?.removeFromSet(node.marks) ?? node.marks).concat();
        if (!!sources?.size) marks.push(dataConsumer.create({
            sources: Array.from(sources)
        }));
        // If the old target sources is now 0 then the data consumer will be removed from the marks. Otherwise a new
        // consumer with updated sources will be injected.
        tr.setNodeMarkup(pos, undefined, node.attrs, marks);
        return tr;
    };
const $2e1ac7157de99f01$export$c4bf0d625842a200 = (schema, target, name)=>(tr)=>{
        const { fragment: fragment } = schema.marks;
        // Quick Check: No point in updating node markup if nothing is changing.
        if (name === target.fragmentMark?.attrs.name) return tr;
        const marks = (target.fragmentMark?.removeFromSet(target.node.marks) ?? target.node.marks).concat();
        marks.push(fragment.create({
            localId: target.fragmentMark?.attrs.localId ?? (0, $fO7hX.uuid).generate(),
            name: name
        }));
        return tr.setNodeMarkup(target.pos, undefined, target.node.attrs, marks);
    };
const $2e1ac7157de99f01$export$599e2146ce482fc4 = (context, element, nodeNameCallback, sources)=>{
    const nodeType = context.schema.nodes[element.type];
    if (!$2e1ac7157de99f01$export$3fdc75161fb8ee49(context.schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(element.type);
    const newNodeUUID = (0, $fO7hX.uuid).generate();
    if (context.hasId(newNodeUUID)) // XXX: Assuming UUID is true this condition should never occur.
    // This is just a safety catch; to protect against lightning strikes.
    throw new (0, $9oPnF.LocalIdCollisionError)(newNodeUUID);
    let attrs;
    if (element.type !== 'table') attrs = element.attrs;
    const { markNameWithNumber: markNameWithNumber } = $2e1ac7157de99f01$export$8a9a3ce4139f59c3({
        type: nodeType,
        attrs: attrs
    }, context.schema, context.getMaxNumberUsedInFragmentMarkNames(), nodeNameCallback);
    if (element.type === 'table') attrs = {
        width: 760
    };
    const node = $2e1ac7157de99f01$export$270e7ba5936d3c48(context.schema, nodeType, attrs, $2e1ac7157de99f01$export$ebf688cb60f59a94(context.schema, newNodeUUID, markNameWithNumber, sources));
    const { inlineExtension: inlineExtension, paragraph: paragraph } = context.schema.nodes;
    // The finalNode is a post-processed node which is eventually added to the document. This may not be the actual
    // element node this was told to create as some nodes may need to be wrapped by others to be safely added  to the document.
    const finalNode = nodeType === inlineExtension ? paragraph.create(undefined, [
        node
    ]) : node;
    return {
        linkNode: $2e1ac7157de99f01$export$dbdf2d08277c626e(newNodeUUID, markNameWithNumber, node),
        node: finalNode
    };
};
const $2e1ac7157de99f01$export$2e109011d5320d15 = (context, targetLocalId, sourceLocalId, tr)=>{
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    if (target.normalizedId === source.normalizedId) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
    // If the current target dataConsumer already has the source linked.
    const hasDataConsumerSource = !!target.dataConsumer?.attrs.sources.some((src)=>source.ids.has(src));
    if (hasDataConsumerSource) // If the connection has already been made, avoid an unnecessary transaction
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
    else {
        if ($2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, source)) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
        const newSources = $2e1ac7157de99f01$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
        // Add the source to the target.
        newSources.add(source.normalizedId);
        tr = $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, newSources)(tr);
    }
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
};
const $2e1ac7157de99f01$export$dba1c2bae2f381b9 = (context, targetLocalId, sourceLocalId, tr)=>{
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
    const targetSources = $2e1ac7157de99f01$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
    // Remove the source from the target (if any) and update the sources if the source was deleted.
    if (targetSources.delete(source.normalizedId)) return $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, targetSources)(tr);
    return tr;
};
const $2e1ac7157de99f01$export$b0852c37ee3e7ea9 = (context, targetLocalId, sourceLocalId, tr)=>{
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetLocalId);
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    if (target.normalizedId === source.normalizedId) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
    // If the current target dataConsumer already has the source linked.
    const hasDataConsumerSource = !!target.dataConsumer?.attrs.sources.every((src)=>source.ids.has(src));
    if (hasDataConsumerSource) // If the connection has already been made, avoid an unnecessary transaction
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
    else {
        if ($2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, source)) throw new (0, $9oPnF.CyclicReferenceError)(targetLocalId, sourceLocalId);
        tr = $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, new Set([
            source.normalizedId
        ]))(tr);
    }
    return {
        target: $2e1ac7157de99f01$export$7503e197531554a8(target),
        source: $2e1ac7157de99f01$export$7503e197531554a8(source),
        tr: tr
    };
};
const $2e1ac7157de99f01$export$73aa87199f4a96f5 = (context, localId, tr)=>{
    const source = context.getById(localId);
    if (!source) throw new (0, $9oPnF.SourceReferenceError)(localId);
    source.targets.forEach((target)=>{
        tr = $2e1ac7157de99f01$export$dba1c2bae2f381b9(context, target, localId, tr);
    });
    return tr;
};
const $2e1ac7157de99f01$export$328b0edc9fda3a36 = (context, oldSourceLocalId, newSourceLocalId, tr)=>{
    // This needs to disconnect the old source from all targets. Then update each target with the new source
    const oldSource = context.getById(oldSourceLocalId);
    if (!oldSource) throw new (0, $9oPnF.SourceReferenceError)(oldSourceLocalId);
    const newSource = context.getById(newSourceLocalId);
    if (!newSource) throw new (0, $9oPnF.SourceReferenceError)(newSourceLocalId);
    // If the old/new source are referring to the same connection then we should avoid unnecessary transactions.
    if (oldSource === newSource) return {
        source: $2e1ac7157de99f01$export$7503e197531554a8(newSource),
        tr: tr
    };
    // Before we do any disconnecting or updating we must ensure a couple things first;
    // 1. The old source targets exist
    // 2. Moving the old source target to the new source doesn't cause a cyclic ref.
    for (const targetId of oldSource.targets){
        const target = context.getById(targetId);
        if (!target) throw new (0, $9oPnF.TargetReferenceError)(targetId);
        if ($2e1ac7157de99f01$export$c85fa7574bd3ee0b(context, target, newSource)) throw new (0, $9oPnF.CyclicReferenceError)(targetId, newSourceLocalId);
        const targetSources = $2e1ac7157de99f01$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
        const deleted = targetSources.delete(oldSource.normalizedId);
        // If the target source doesn't have the new source then it will be added.
        const added = !targetSources.has(newSource.normalizedId);
        targetSources.add(newSource.normalizedId);
        if (deleted || added) tr = $2e1ac7157de99f01$export$6c4da287bd77d75c(context.schema, target, targetSources)(tr);
    }
    return {
        source: $2e1ac7157de99f01$export$7503e197531554a8(newSource),
        tr: tr
    };
};
const $2e1ac7157de99f01$export$fb891e3743d8c30f = (context, sourceLocalId, target, tr, nodeNameCallback, oldTargetLocalId)=>{
    const nodeType = context.schema.nodes[target.type];
    if (!$2e1ac7157de99f01$export$3fdc75161fb8ee49(context.schema).has(nodeType)) throw new (0, $9oPnF.UnsupportedTypeError)(target.type);
    if (!context.hasId(sourceLocalId)) throw new (0, $9oPnF.SourceReferenceError)(sourceLocalId);
    const { linkNode: linkNode, node: node } = $2e1ac7157de99f01$export$599e2146ce482fc4(context, target, nodeNameCallback, [
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        context.getById(sourceLocalId).normalizedId
    ]);
    if (!!oldTargetLocalId) // If an old target id has been supplied then this insert action is
    // replacing and old connection, so we need to disconnect the
    // old connection, then insert the new node.
    tr = $2e1ac7157de99f01$export$dba1c2bae2f381b9(context, oldTargetLocalId, sourceLocalId, tr);
    tr = $2e1ac7157de99f01$export$9c63b8d16fa708c5(sourceLocalId, node, context.state, tr);
    tr = tr.setMeta('referentialityTableInserted', node.type.name === context.schema.nodes.table.name);
    return {
        linkNode: linkNode,
        tr: tr
    };
};
module.exports["getNodeTypesSupported"] = $2e1ac7157de99f01$export$8174b2693cae81eb;
module.exports["getNodesSupportingFragmentMark"] = $2e1ac7157de99f01$export$3fdc75161fb8ee49;
module.exports["createConnectionLink"] = $2e1ac7157de99f01$export$54a3e405bb0d0a4a;
module.exports["decodeName"] = $2e1ac7157de99f01$export$368b1080eb192086;
module.exports["generateMarkNameWithNumber"] = $2e1ac7157de99f01$export$8a9a3ce4139f59c3;
module.exports["createLinkNode"] = $2e1ac7157de99f01$export$dbdf2d08277c626e;
module.exports["findNodeByLocalId"] = $2e1ac7157de99f01$export$aadcc3ba2430b;
module.exports["insertNodeAfter"] = $2e1ac7157de99f01$export$9c63b8d16fa708c5;
module.exports["normalizeIds"] = $2e1ac7157de99f01$export$4c47e28146a39728;
module.exports["updateSources"] = $2e1ac7157de99f01$export$6c4da287bd77d75c;
module.exports["updateNodeSources"] = $2e1ac7157de99f01$export$884cb393b34cee0d;
module.exports["updateFragmentName"] = $2e1ac7157de99f01$export$c4bf0d625842a200;
module.exports["createLinkElementNode"] = $2e1ac7157de99f01$export$599e2146ce482fc4;
module.exports["connectNodes"] = $2e1ac7157de99f01$export$2e109011d5320d15;
module.exports["disconnectNodes"] = $2e1ac7157de99f01$export$dba1c2bae2f381b9;
module.exports["resetNodes"] = $2e1ac7157de99f01$export$b0852c37ee3e7ea9;
module.exports["insertTarget"] = $2e1ac7157de99f01$export$fb891e3743d8c30f;

});

parcelRegister("9oPnF", function(module, exports) {
class $4157e5902416a90b$export$fa0bafaea078bc3e extends Error {
    constructor(reason){
        super(`Unable to attach, Incorrect configuration: ${reason}`), this.reason = reason;
    }
}
class $4157e5902416a90b$export$c9ab3ad70477eb extends Error {
    constructor(handlerName){
        super(`Unable to execute ${handlerName}, API hasn't been initialized`), this.handlerName = handlerName;
    }
}
class $4157e5902416a90b$export$6b13996afffc6894 extends Error {
    constructor(){
        super('An Error occured during Initialization');
    }
}
class $4157e5902416a90b$export$e162153238934121 extends Error {
    constructor(){
        super('API not implemented');
    }
}
class $4157e5902416a90b$export$fef5df6faf884a63 extends Error {
    constructor(type){
        super(`Unsupported type (${type})`);
    }
}
class $4157e5902416a90b$export$8ef43b75008b17aa extends ReferenceError {
    constructor(localId){
        super(`Node (${localId}) could not be found`), this.localId = localId;
    }
}
class $4157e5902416a90b$export$88aaf39bc2cab9a8 extends $4157e5902416a90b$export$8ef43b75008b17aa {
    constructor(localId){
        super(localId), this.localId = localId;
    }
}
class $4157e5902416a90b$export$311a85310d085910 extends $4157e5902416a90b$export$8ef43b75008b17aa {
    constructor(localId){
        super(localId), this.localId = localId;
    }
}
class $4157e5902416a90b$export$1a3d80e823d9a375 extends ReferenceError {
    constructor(targetLocalId, sourceLocalId){
        super(`Connecting Target (${targetLocalId}) to Source (${sourceLocalId}) will result in a Circular Reference`), this.targetLocalId = targetLocalId, this.sourceLocalId = sourceLocalId;
    }
}
class $4157e5902416a90b$export$d754643475748116 extends ReferenceError {
    constructor(localId){
        super(`LocalId (${localId}) Collision has occured`), this.localId = localId;
    }
}
module.exports["CompatibilityError"] = $4157e5902416a90b$export$fa0bafaea078bc3e;
module.exports["ConfigurationError"] = $4157e5902416a90b$export$c9ab3ad70477eb;
module.exports["UnsupportedTypeError"] = $4157e5902416a90b$export$fef5df6faf884a63;
module.exports["NodeNotFoundError"] = $4157e5902416a90b$export$8ef43b75008b17aa;
module.exports["TargetReferenceError"] = $4157e5902416a90b$export$88aaf39bc2cab9a8;
module.exports["SourceReferenceError"] = $4157e5902416a90b$export$311a85310d085910;
module.exports["CyclicReferenceError"] = $4157e5902416a90b$export$1a3d80e823d9a375;
module.exports["LocalIdCollisionError"] = $4157e5902416a90b$export$d754643475748116;

});

parcelRegister("2PvyV", function(module, exports) {

var $d925B = parcelRequire("d925B");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32b6226d0cdd6a9e$var$getPayload = (payload)=>({
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        tags: [
            'editor'
        ],
        ...payload
    });
const $32b6226d0cdd6a9e$export$12008b1cff7b5512 = ({ docSize: docSize, count: count, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).INITIALISED_FRAGMENT_MARK,
            attributes: {
                duration: duration,
                docSize: docSize,
                count: count
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$bff45a9f8c570c00 = ({ docSize: docSize, sourceNodeType: sourceNodeType, targetNodeType: targetNodeType, type: type, actionType: actionType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).CONNECTED_NODES,
            attributes: {
                duration: duration,
                docSize: docSize,
                sourceNodeType: sourceNodeType,
                targetNodeType: targetNodeType,
                type: type,
                actionType: actionType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$d0d121977041a37d = ({ docSize: docSize, oldSourceNodeType: oldSourceNodeType, newSourceNodeType: newSourceNodeType, type: type, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).UPDATED_SOURCE,
            attributes: {
                duration: duration,
                docSize: docSize,
                oldSourceNodeType: oldSourceNodeType,
                newSourceNodeType: newSourceNodeType,
                type: type
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$9f5791db63c112cc = ({ docSize: docSize, targetNodeType: targetNodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).DISCONNECTED_SOURCE,
            attributes: {
                duration: duration,
                docSize: docSize,
                targetNodeType: targetNodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$1bb576f3f4bb0389 = ({ docSize: docSize, sourceNodeType: sourceNodeType, targetNodeType: targetNodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).DISCONNECTED_TARGET,
            attributes: {
                duration: duration,
                docSize: docSize,
                sourceNodeType: sourceNodeType,
                targetNodeType: targetNodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$41746208cd3b8ef5 = ({ docSize: docSize, newTargetNodeType: newTargetNodeType, oldTargetNodeType: oldTargetNodeType, sourceNodeType: sourceNodeType, type: type, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).UPDATED_TARGET,
            attributes: {
                duration: duration,
                docSize: docSize,
                newTargetNodeType: newTargetNodeType,
                oldTargetNodeType: oldTargetNodeType,
                sourceNodeType: sourceNodeType,
                type: type
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$6f3cdc6bed2f6e2e = ({ nodeType: nodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).UPDATED_FRAGMENT_MARK_NAME,
            attributes: {
                duration: duration,
                nodeType: nodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $32b6226d0cdd6a9e$export$c56def702d19a484 = ({ count: count, docSize: docSize, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $32b6226d0cdd6a9e$var$getPayload({
            action: (0, $d925B.ACTION).GOT_CONNECTIONS,
            attributes: {
                docSize: docSize,
                duration: duration,
                count: count
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
module.exports["captureInitialiseFragmentMarksEvent"] = $32b6226d0cdd6a9e$export$12008b1cff7b5512;
module.exports["captureConnectNodesEvent"] = $32b6226d0cdd6a9e$export$bff45a9f8c570c00;
module.exports["captureUpdateSourceEvent"] = $32b6226d0cdd6a9e$export$d0d121977041a37d;
module.exports["captureDisconnectSourceEvent"] = $32b6226d0cdd6a9e$export$9f5791db63c112cc;
module.exports["captureDisconnectTargetEvent"] = $32b6226d0cdd6a9e$export$1bb576f3f4bb0389;
module.exports["captureUpdateTargetEvent"] = $32b6226d0cdd6a9e$export$41746208cd3b8ef5;
module.exports["captureUpdateFragmentMarkNameEvent"] = $32b6226d0cdd6a9e$export$6f3cdc6bed2f6e2e;
module.exports["captureGetConnectionsEvent"] = $32b6226d0cdd6a9e$export$c56def702d19a484;

});

parcelRegister("87lhs", function(module, exports) {
// This is a Statsig experiment
const $5e97256736fa056e$export$977ce18f16415288 = 'confluence_frontend_macro_interaction_design';
module.exports["MACRO_INTERACTION_DESIGN_UPDATES"] = $5e97256736fa056e$export$977ce18f16415288;

});

parcelRegister("4xvYZ", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $4tb0i = parcelRequire("4tb0i");

const $20c78fd742182292$export$5e2881449d7cf240 = (editorActions)=>{
    const state = editorActions?._privateGetEditorView()?.state;
    if (!state) return null;
    const selection = state.selection;
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        const dataSourceId = selection.node.marks?.find((mark)=>mark.type === state.schema?.marks?.dataConsumer)?.attrs?.sources[0];
        if (!dataSourceId) return null;
        const dataSourceProvider = (0, $4tb0i.getPluginState)(state)?.dataSourceProvider;
        return dataSourceProvider?.get(dataSourceId);
    }
};
module.exports["dataSourceResolver"] = $20c78fd742182292$export$5e2881449d7cf240;

});

parcelRegister("eVKuj", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $gcCrc = parcelRequire("gcCrc");

// Getting all nodes mapping (LocalId => ADNode)
const $807577750dac8d47$var$getAllNodes = (nodes = [])=>{
    let allNodes = new Map();
    nodes.forEach((node)=>{
        const existingFragmentMark = node.marks?.find((m)=>m.type === 'fragment');
        const fragmentLocalId = existingFragmentMark?.attrs?.localId;
        if (fragmentLocalId) allNodes.set(fragmentLocalId, node);
        if (node.attrs?.localId) allNodes.set(node.attrs.localId, node);
        if (node.content) allNodes = new Map([
            ...allNodes,
            ...$807577750dac8d47$var$getAllNodes(node.content)
        ]);
    });
    return allNodes;
};
const $807577750dac8d47$var$memoGetAllNodes = (0, $2XqLN.default)((adf)=>$807577750dac8d47$var$getAllNodes(adf.content));
const $807577750dac8d47$export$cd3f7ccaa044b456 = ({ adf: adf, extensionParams: extensionParams, dataSourceProvider: dataSourceProvider })=>{
    const allADFNodes = $807577750dac8d47$var$memoGetAllNodes(adf);
    const activeNodeFromADF = allADFNodes.get(extensionParams.localId);
    // At the moment we support only one data consumer
    const dataSourceId = activeNodeFromADF?.marks?.find((mark)=>mark.type === 'dataConsumer')?.attrs?.sources?.[0];
    const [reference, setReference] = (0, $42omo.useState)(()=>{
        const dataSourceNode = allADFNodes.get(dataSourceId);
        // At the momment only table nodes as a source are supported
        if (dataSourceNode?.type === 'table') return {
            [(0, $gcCrc.ADFReferenceTypes).TABLE]: dataSourceNode
        };
    });
    (0, $42omo.useEffect)(()=>{
        if (!dataSourceId) return;
        dataSourceProvider?.subscribe(dataSourceId, setReference);
        return ()=>dataSourceProvider?.unsubscribe(dataSourceId, setReference);
    }, [
        dataSourceProvider,
        dataSourceId
    ]);
    return {
        references: reference ? [
            reference
        ] : []
    };
};
module.exports["useReference"] = $807577750dac8d47$export$cd3f7ccaa044b456;

});


//# sourceMappingURL=CommentsPanelWrapper.8ecbcc07.js.map
